const state = {
  approveStatus: [
    {label: '待审批', value: 0},
    {label: '已通过', value: 1},
    {label: '已驳回', value: 2},
  ]
}

// mutations
const mutations = {
}

export const middleEndTask = {
  namespaced: true,
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/middle-end-task/middle-end-task.store.js